import { additional_colors } from 'console/theme/styles/additional-colors';
function rowStyle(color) {
    return {
        backgroundColor: color.light,
        color: color.contrastText,
        '&.MuiTableRow-hover:hover, &.Mui-focusVisible': {
            backgroundColor: color.dark,
        },
        '& .MuiTableCell-root, .MuiInputBase-input': {
            color: color.contrastText,
        },
    };
}
const row_colors = [
    ...additional_colors,
    'error',
    'warning',
    'info',
    'success',
    'secondary',
];
export function getRowVariants(theme_colors) {
    return row_colors.flatMap((color) => {
        return [
            {
                props: { color },
                //@ts-ignore
                style: rowStyle(theme_colors[color]),
            },
        ];
    });
}
